
























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import request from '@/utils/request';
import AMSExpand from './AMSExpand';
import moment from 'moment';
import { AppStore } from '@/store/modules/app';
import AMSTooltip from '@/components/AMSTooltip.vue';
import utils from '@/utils/utils';
@Component({
  components: {
    'ams-expand': AMSExpand,
    'ams-tooltip': AMSTooltip
  }
})
export default class AMSTable extends Vue {
  @Prop({ type: Array, required: true, default: [] })
  headers!: ITableHeader[];
  @Prop({
    type: Array,
    default: () => {
      return new Array();
    }
  })
  value!: any[] | undefined;
  @Prop({ default: false }) isSelectAll!: boolean;
  selected: Array<any> = [];
  constructor() {
    super();
  }
  items = this.value;
  isLoading = false;
  searchLoading = false;
  productSearch: string = '';
  search = '';
  otherData: object = {};
  isShow(prop: any, index: number, btn?: any) {
    return btn.isShowBtn ? btn.isShowBtn(prop.item) : true;
  }
  formatDateTime(date: any) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }
  getPermission(name: string) {
    return utils.isPermission(name);
  }
  renderList(item: any) {
    if (item.customer.sales) {
      return item.customer.sales
        .map((sale: any) => {
          return sale.staff.name;
        })
        .join('、');
    }
  }
  orderDetail(item: any, type: string) {
    if (item.orderType === 'MaterialOrder') {
      this.$router.push({ name: 'materials_view', query: { id: item.orderId, tabActive: type } });
    } else {
      this.$router.push({ name: 'orderList_details', query: { id: item.orderId, tabActive: type } });
    }
  }
  @Watch('value')
  valueUpdate(value: any) {
    this.items = value;
    this.otherData = {
      totalFreezeAmount: value.totalFreezeAmount
    };
  }
  @Watch('otherData')
  changeOtherData(val: any) {
    this.otherData = val;
    this.$emit('getOtherData', this.otherData);
  }
}

export interface ITableHeader {
  text: string;
  value: string;
  align: string;
  sortable: boolean;
  class: string[] | string;
  width: string;
  edit: boolean;
  format: Function;
}
